"use client";

import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import React, { useState } from "react";

import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { StyledContainer, StyledRoot } from "./styles";
import SalifyLink from "src/lib/components/link/salify-link";

interface TopbarProps {
  bgColor?: string;
  socialLinks?: Array<{
    type: "facebook" | "twitter" | "youtube" | "pinterest" | "instagram";
    url: string;
  }>;
  notification: {
    text: string;
    type: string;
    label: string;
  };
  colors: {
    primary: string;
  };
}

const ICON_MAPPING: {
  [key in "facebook" | "twitter" | "youtube" | "pinterest" | "instagram"]: any;
} = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  youtube: YouTubeIcon,
  pinterest: PinterestIcon,
  instagram: InstagramIcon,
};

const Topbar: React.FC<TopbarProps> = ({ bgColor, socialLinks, notification, colors }) => {
  const [expand, setExpand] = useState(false);

  return (
    <StyledRoot {...{ bgColor, expand: expand ? 1 : 0 }}>
      <StyledContainer>
        <FlexBetween width="100%">
          <FlexBox alignItems="center" gap={1}>
            <Chip
              label={notification.label}
              size="small"
              sx={{
                color: "white",
                fontWeight: 700,
                backgroundColor: colors?.primary ?? "primary",
                "& .MuiChip-label": {
                  pl: ".8rem",
                  pr: ".8rem",
                },
              }}
            />
            <span className="title">{notification.text}</span>
          </FlexBox>

          <IconButton disableRipple className="expand" onClick={() => setExpand((state) => !state)}>
            {expand ? <Remove /> : <Add />}
          </IconButton>
        </FlexBetween>

        <FlexBox className="topbarRight" alignItems="center">
          {socialLinks && (
            <FlexBox alignItems="center" gap={1.5}>
              {socialLinks.map(({ type, url }, index) => {
                const Icon = ICON_MAPPING[type];
                return (
                  <SalifyLink style={{ color: "white" }} href={url} key={index}>
                    <Icon
                      sx={{
                        fontSize: 16,
                      }}
                    />
                  </SalifyLink>
                );
              })}
            </FlexBox>
          )}
        </FlexBox>
      </StyledContainer>
    </StyledRoot>
  );
};

export default Topbar;
